import { InjectionToken } from "@angular/core";

/** A section projected into app-cerrix-slide-out-edit-item, asked before the user leaves it. */
export interface CerrixSlideOutEditItemSection {
    hasUnsavedChanges(): boolean;
    /** Resolves false when nothing was saved, so the slide-out stays on the section. */
    save(): Promise<boolean>;
}

export const CERRIX_SLIDE_OUT_EDIT_ITEM_SECTION = new InjectionToken<CerrixSlideOutEditItemSection>(
    "CerrixSlideOutEditItemSection",
);
